export const calendarLocale = {
     /* starting with Sunday */
     days: 'Воскресенье_Понедельник_Вторник_Среда_Четеверг_Пятница_Суббота'.split('_'),
     daysShort: 'Пн_Вт_Ср_Чт_Пт_Сб_Вс'.split('_'),
     months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
     monthsShort: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
     firstDayOfWeek: 1, // 0-6, 0 - Sunday, 1 Monday, ...
     format24h: true,
     pluralDay: 'дней'
}

// random colors
const hexCharacters = [0,1,2,3,4,5,6,7,8,9,"A","B","C","D","E","F"]

export function getTZOffsetPlusOne(date: Date) {
  const sign = (date.getTimezoneOffset() > 0) ? -1 : 1;
  const offset = Math.abs(date.getTimezoneOffset());
  const hours = Math.floor(offset / 60);
  const minutes = offset % 60;
  return sign * (minutes > 0 ? hours + 1 : hours);
}

// for proper rounding to 2 decimal digits
export function roundTo(num: number, places: number) {
  return Number(`${Math.round(+`${num}e${places}`)}e-${places}`)
}

export function customIsDate(text: string) {
  const pattern = /\b(\d{2})\.(\d{2})\.(\d{4})\b/;
  const match = pattern.exec(text);
  if (match) {
    const [, day, month, year] = match;
    const d = parseInt(day, 10);
    const m = parseInt(month, 10);
    const y = parseInt(year, 10);
    if (d >= 1 && d <= 31 && m >= 1 && m <= 12 && y >= 1900 && y <= 2100) {
      return true;
    }
  }
  return false;
}

export function shuffleArray (arr: any[]) {
     for (let i = arr.length - 1; i > 0; i--) {
       const j = Math.floor(Math.random() * (i + 1));
       [arr[i], arr[j]] = [arr[j], arr[i]];
     }
     return arr;
   }

function getCharacter(index: number) {
     const hexCh = shuffleArray(hexCharacters)
    return hexCh[index]
}

export function normalizeTokens(text: string) {
  const tokens = text
  .split('')
  .reduce((acc: string[], char) => {
    if (/\s+/.test(char)) {
      acc.push(' ');
    } else if (acc.length > 0 && !/\s+/.test(acc[acc.length - 1])) {
      acc[acc.length - 1] += char;
    } else {
      acc.push(char);
    }
    return acc;
  }, []);
  // console.log('tokens: '+tokens)
  return tokens
}

export function generateNewColor() {
    let hexColorRep = "#"
    for (let index = 0; index < 6; index++){
        const randomPosition = Math.floor ( Math.random() * hexCharacters.length ) 
        hexColorRep += getCharacter( randomPosition )
    }
    return hexColorRep
}

/**
 * Formats LOCAL current time as ISO-like string with explicit +00:00 suffix.
 * Important: this does not convert to UTC; it keeps local clock values.
 */
export function formatLocalDateTimeAsPlus00(date: Date = new Date()): string {
  const pad2 = (n: number) => String(n).padStart(2, "0");
  const year = date.getFullYear();
  const month = pad2(date.getMonth() + 1);
  const day = pad2(date.getDate());
  const hours = pad2(date.getHours());
  const minutes = pad2(date.getMinutes());
  const seconds = pad2(date.getSeconds());
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000+00:00`;
}
